import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, ChildrenOutletContexts, NavigationEnd, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { LanguageService } from '@shared/services';
import { filter, map, take } from 'rxjs';
import { AuthenticationService } from '@shared/services/authentication.service';
import { ThemeService } from './services/theme.service';
import { slideInAnimation } from '@shared/animations';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  animations: [slideInAnimation]
})
export class AppComponent implements OnInit {
  enableSharedComponent = false;
  showKnowledgeBaseBubble = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _renderer: Renderer2,
    private _themeService: ThemeService,
    private _languageService: LanguageService,
    private _authenticationService: AuthenticationService,
    private _contexts: ChildrenOutletContexts
  ) {
    if (environment.production && environment.clarityProjectId) {
      this._addClarityScriptsToHeadTag(environment.clarityProjectId);
    }

    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this._getActivatedChild(this._activatedRoute.snapshot)),
        filter((snapshot: ActivatedRouteSnapshot | null): snapshot is ActivatedRouteSnapshot => snapshot !== null),
        map((snapshot: ActivatedRouteSnapshot) => snapshot.data['enableSharedComponent'])
      )
      .subscribe((enable: boolean | undefined) => {
        this.enableSharedComponent = enable !== false;

        const isLoginRoute = this._router.url.startsWith('/login') || this._router.url === '/';
        this._authenticationService.user.pipe(take(1)).subscribe((user) => {
          this.showKnowledgeBaseBubble = !!user && !isLoginRoute;
        });
      });

    this._renderer.addClass(document.body, this._themeService.currentTheme);
  }

  ngOnInit() {
    this._languageService.init();
  }

  getRouteAnimationData() {
    return this._contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
  }

  private _getActivatedChild(snapshot: ActivatedRouteSnapshot): ActivatedRouteSnapshot | null {
    if (snapshot.firstChild) {
      return this._getActivatedChild(snapshot.firstChild);
    }
    return snapshot;
  }

  private _addClarityScriptsToHeadTag(clarityProjectId: string) {
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    const textContent = `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window, document, "clarity", "script", "${clarityProjectId}");`;
    script.textContent = textContent;
    script.async = true;
    head.insertBefore(script, head.firstChild);
  }
}
